/* eslint-disable standard/object-curly-even-spacing */
import React, { useState } from 'react'
import { ApolloConsumer, graphql } from 'react-apollo'

import gql from 'graphql-tag'
import { withRouter } from 'react-router-dom'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import AddBrandModal from './AddBrandModal'
import AddModelModal from './AddModelModal'
import EditBrandModal from './EditBrandModal'
import DeleteBrandModal from './DeleteBrandModal'
import EditModelModal from './EditModelModal'
import DeleteModelModal from './DeleteModelModal'
import {
  Grid,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
  Button,
  CircularProgress
} from '@material-ui/core'
import getLoginId from '../../../utils/getLoginId'

const GET_BRANDS = gql`
  query GetBrands($clientLoginId: Int!) {
    getBrands(clientLoginId: $clientLoginId) {
      status
      message
      data {
        id
        name
      }
    }
  }
`

const GET_MODELS_BY_BRAND = gql`
  query GetModelsByBrand($brandId: Int!, $clientLoginId: Int!) {
    getModelsByBrand(brandId: $brandId, clientLoginId: $clientLoginId) {
      status
      message
      data {
        id
        name
        cum_weight
      }
    }
  }
`

const BrandModelConfiguration = ({
  data: { loading, error, getBrands, refetch },
  match
}) => {
  const loginId = getLoginId()
  console.log('loginId', loginId)
  const [editBrandModal, setEditBrandModal] = useState({
    open: false,
    brandId: null
  })
  const [editModelModal, setEditModelModal] = useState({
    open: false,
    model: null
  })
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [selectedModelId, setSelectedModelId] = useState(null)
  const [expandedBrand, setExpandedBrand] = useState(null)
  const [models, setModels] = useState({})
  const [openModal, setOpenModal] = useState(false)
  const [openAddModelModal, setOpenAddModelModal] = useState(false)
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)
  const [selectedBrand, setSelectedBrand] = useState(null)
  const handleAccordionChange = (client, brandId) => async (
    event,
    isExpanded
  ) => {
    if (isExpanded) {
      setExpandedBrand(brandId)

      const response = await client.query({
        query: GET_MODELS_BY_BRAND,
        variables: { brandId, clientLoginId: loginId },
        fetchPolicy: 'no-cache'
      })

      setModels(prevModels => ({
        ...prevModels,
        [brandId]: response.data.getModelsByBrand.data
      }))
    } else {
      setExpandedBrand(null)
    }
  }

  const handleAddBrandClick = () => {
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }
  const handleAddModelClick = () => {
    setOpenAddModelModal(true)
  }

  const handleCloseAddModelModal = () => {
    setOpenAddModelModal(false)
  }
  const handleEditBrandClick = brandId => {
    setEditBrandModal({ open: true, brandId })
  }

  const handleCloseEditBrandModal = () => {
    setEditBrandModal({ open: false, brandId: null })
  }

  const handleDeleteClick = brandId => {
    setSelectedBrand(brandId)
    setDeleteModalOpen(true)
  }

  const closeDeleteModal = () => {
    setDeleteModalOpen(false)
    setSelectedBrand(null)
  }
  const refetchBrands = () => {
    refetch()
  }
  const handleEditModelClick = model => {
    setEditModelModal({ open: true, model })
  }

  const handleCloseEditModelModal = () => {
    setEditModelModal({ open: false, model: null })
  }
  const handleDeleteIconClick = modelId => {
    setSelectedModelId(modelId)
    setOpenDeleteModal(true)
  }

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false)
    setSelectedModelId(null)
  }
  const handleEditBrandSuccess = () => {
    console.log('sdsdsdsd')

    setExpandedBrand(null)
  }
  if (loading) return <CircularProgress />
  if (error) return <p>Error: {error.message}</p>

  const brands = getBrands && getBrands.data ? getBrands.data : []

  console.log('editModelModal', editModelModal)

  return (
    <ApolloConsumer>
      {client => (
        <div style={{ padding: '30px' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '20px'
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontWeight: 'bold' }}
            >
              Truck Brand & Model Configuration
            </Typography>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
                marginBottom: '20px'
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handleAddBrandClick}
                style={{ color: 'white', background: 'blue' }}
              >
                + Add Brand
              </Button>
              <Button
                variant="contained"
                // color="success"
                onClick={handleAddModelClick}
                style={{ color: 'white', background: '#3bb143' }}
              >
                + Add Model
              </Button>
            </div>
          </div>

          <div>
            {brands.map(brand => (
              <ExpansionPanel
                key={brand.id}
                expanded={expandedBrand === brand.id}
                onChange={handleAccordionChange(client, brand.id)}
                style={{
                  borderRadius: '5px',
                  marginBottom: '10px'
                }}
              >
                <ExpansionPanelSummary
                  // expandIcon={<ExpandMoreIcon />}
                  style={{
                    background: '#F5F5F5',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                  }}
                >
                  <div
                    style={{
                      marginRight: '10px',
                      cursor: 'pointer', 
                    }}
               
                  >
                    <ExpandMoreIcon />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%'
                    }}
                  >
                    <Typography>{brand.name}</Typography>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <Typography
                        variant="body1"
                        style={{
                          color: 'blue',
                          cursor: 'pointer',
                          fontWeight: '500'
                        }}
                        onClick={event => {
                          event.stopPropagation()
                          handleEditBrandClick(brand.id)
                        }}
                      >
                        Edit
                      </Typography>
                      <Typography
                        variant="body1"
                        style={{
                          color: 'red',
                          cursor: 'pointer',
                          fontWeight: '500'
                        }}
                        onClick={event => {
                          event.stopPropagation()
                          handleDeleteClick(brand.id)
                        }}
                      >
                        Delete
                      </Typography>
                    </div>
                  </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  {expandedBrand !== brand.id ? (
                    <CircularProgress size={24} />
                  ) : (
                    <Grid container spacing={2}>
                      {(models[brand.id] || []).map(model => (
                        <Grid item xs={12} key={model.id}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              borderBottom: '1px solid #e0e0e0',
                              padding: '10px 0'
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                gap: '10px',
                                alignItems: 'center'
                              }}
                            >
                              <Typography
                                variant="body1"
                                style={{ fontWeight: '500' }}
                              >
                                {model.name}
                              </Typography>
                              {/* <Typography
                                variant="body2"
                                style={{ color: 'gray', fontWeight: '500' }}
                              >
                                Capacity: {model.cum_weight}
                              </Typography> */}
                            </div>

                            <div style={{ display: 'flex', gap: '10px' }}>
                              <Typography
                                variant="body1"
                                style={{
                                  color: 'blue',
                                  cursor: 'pointer',
                                  fontWeight: '500'
                                }}
                                onClick={event => {
                                  event.stopPropagation()
                                  handleEditModelClick(model.id)
                                }}
                              >
                                Edit
                              </Typography>
                              <Typography
                                variant="body1"
                                style={{
                                  color: 'red',
                                  cursor: 'pointer',
                                  fontWeight: '500'
                                }}
                                onClick={event => {
                                  event.stopPropagation()
                                  handleDeleteIconClick(model.id)
                                }}
                              >
                                Delete
                              </Typography>
                            </div>
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </ExpansionPanelDetails>
              </ExpansionPanel>
            ))}
          </div>
          <AddBrandModal
            open={openModal}
            onClose={handleCloseModal}
            refetchBrands={refetchBrands}
            clientLoginId={loginId}
          />
          <AddModelModal
            open={openAddModelModal}
            onClose={handleCloseAddModelModal}
            clientLoginId={loginId}
            refetchBrands={refetchBrands}
          />
          <EditBrandModal
            open={editBrandModal.open}
            onClose={handleCloseEditBrandModal}
            brandId={editBrandModal.brandId}
            clientLoginId={loginId}
            refetchBrands={refetchBrands}
          />
          <DeleteBrandModal
            open={deleteModalOpen}
            onClose={closeDeleteModal}
            brandId={selectedBrand}
            clientLoginId={loginId}
            refetchBrands={refetchBrands}
          />
          <EditModelModal
            open={editModelModal.open}
            onClose={handleCloseEditModelModal}
            modelId={editModelModal.model}
            clientLoginId={loginId}
            refetchBrands={refetchBrands}
            onEditSuccess={handleEditBrandSuccess}
          />
          <DeleteModelModal
            open={openDeleteModal}
            onClose={handleCloseDeleteModal}
            modelId={selectedModelId}
            clientLoginId={loginId}
            refetchBrands={refetchBrands}
            onEditSuccess={handleEditBrandSuccess}
          />
        </div>
      )}
    </ApolloConsumer>
  )
}

export default graphql(GET_BRANDS, {
  options: () => ({
    variables: { clientLoginId: getLoginId() } 
  })
})(withRouter(BrandModelConfiguration))


// WEBPACK FOOTER //
// ./src/components/Pages/modalConfigure/BrandModelConfiguration.jsx